require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-vogue-living-house-tour-middle-park-residence.json") })
        }
      }, "path---journal-vogue-living-house-tour-middle-park-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-vogue-living-house-tour-middle-park-residence!./.cache/json/journal-vogue-living-house-tour-middle-park-residence.json
// module id = 555
// module chunks = 231608221292675